import FreeSubscriptions from '@/views/free-subscriptions/free-subscriptions.vue'
import AddFreeSubscription from '@/views/free-subscriptions/free-subscriptions-new.vue'
import ShowFreeSubscription from '@/views/free-subscriptions/free-subscriptions-show.vue'
import { FreeSubscriptionsRouteNames } from '@/router/routes-names'

export const freeSubscriptionsRoutes = [
    {
        path: '/free-subscriptions',
        name: FreeSubscriptionsRouteNames.LIST,
        component: FreeSubscriptions,
        props: true
    },
    {
        path: '/free-subscriptions/new',
        name: FreeSubscriptionsRouteNames.NEW,
        component: AddFreeSubscription
    },
    {
        path: '/free-subscriptions/show/:subscriptionId',
        name: FreeSubscriptionsRouteNames.SHOW,
        component: ShowFreeSubscription
    }
]
